import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    article_tab_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        backgroundColor: theme.palette.background.default,
    },
    article_summary: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: 12,
        padding: 12,
        backgroundColor: theme.palette.grey[50],
        borderRadius: 4,
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    summary_item: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    summary_label: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        fontWeight: 500,
    },
    summary_value: {
        fontSize: 16,
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    profit_positive: {
        color: theme.palette.success.main,
    },
    profit_negative: {
        color: theme.palette.error.main,
    },
    orders_list: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: '0 20px',
    },
    loading: {
        padding: 20,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    empty_state: {
        padding: 20,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.grey[50],
        borderRadius: 4,
    },
    order_item: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 4,
        overflow: 'hidden',
        backgroundColor: theme.palette.common.white,
    },
    order_header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        backgroundColor: theme.palette.grey[50],
        transition: 'background-color 0.2s',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        }
    },
    order_header_left: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flex: 1,
    },
    order_number: {
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.text.primary,
        minWidth: 100,
    },
    order_header_right: {
        display: 'flex',
        alignItems: 'center',
        gap: 50,
    },
    order_profit: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 2,
    },
    profit_label: {
        fontSize: 11,
        color: theme.palette.text.secondary,
    },
    profit_value: {
        fontSize: 14,
        fontWeight: 700,
    },
}));

export {useStyles}